import React from 'react';
export default () => {
  return (
    <span className="AppTitle">
      <span className="title-my">my</span>
      <span className="title-law">law</span>
    </span>
  );
};
